<template>
  <span class="download-input">
    <form action="/api/admin/form/download" method="post" ref="form">
      <input type="hidden" name="token" v-model="token">
      <input type="hidden" name="permalink" v-model="options.permalink">
      <input type="hidden" name="data" v-model="stringVal">
    </form>
    <button v-if="options.button" class="btn btn-indigo my-2" type="button" @click="download()" :disabled="disabled">
      <span class="fa fa-download fa-fw"></span> {{ options.label || 'Download' }}
    </button>
    <a v-else @click="download()" class="link" :class="{ 'disabled': disabled }">
      {{ options.label || 'Download' }}
    </a>
  </span>
</template>

<style scoped>
  @media (min-width: 575px) {
    .download-input {
      display: inline-block;
    }
  }
  .link, a:not([href]):not([tabindex]) {
    color: #00bcd4;
    transition: all 0.3s ease 0s;
    cursor: pointer;
  }
  .link:hover {
    color: #0097a7 !important;
    text-decoration: underline !important;
  }
</style>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
export default {
  name: 'DownloadInput',
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          permalink: ''
        }
      }
    }
  },
  data () {
    return {
      isValid: true,
      isDirty: true,
      token: '',
      stringVal: ''
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  methods: {
    async download () {
      this.stringVal = JSON.stringify(this.value)
      this.token = window.sessionStorage.getItem('token')
      await this.$nextTick()
      this.$refs.form.submit()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DownloadInput.vue